import { useEffect, useState } from "react";
import { PageHeader, Panel } from "../components/Surface";
import { listFlags, setFlag, type FeatureFlag } from "../lib/admin";

export function AdminFlags() {
  const [flags, setFlags] = useState<FeatureFlag[]>([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState<string | null>(null);

  async function refresh() {
    setFlags((await listFlags()).flags);
  }
  useEffect(() => { refresh().finally(() => setLoading(false)); }, []);

  async function toggle(f: FeatureFlag) {
    setBusy(f.key);
    try { await setFlag(f.key, !f.enabled); await refresh(); } finally { setBusy(null); }
  }

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-6">
      <PageHeader title="Feature flags" subtitle="Global runtime toggles. Every change is written to the audit log." />
      {loading ? (
        <p className="font-mono text-sm text-muted">Loading…</p>
      ) : (
        <Panel title={`Flags (${flags.length})`}>
          <ul className="grid gap-2">
            {flags.map((f) => (
              <li key={f.key} className="flex items-center justify-between gap-4 border-b border-line pb-2 last:border-0 last:pb-0">
                <div className="grid gap-0.5">
                  <span className="font-mono text-sm font-bold">{f.key}</span>
                  {f.description && <span className="text-[11px] text-muted">{f.description}</span>}
                </div>
                <button
                  type="button"
                  role="switch"
                  aria-checked={f.enabled}
                  aria-label={`Toggle ${f.key}`}
                  disabled={busy === f.key}
                  onClick={() => toggle(f)}
                  data-testid={`flag-${f.key}`}
                  className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${f.enabled ? "bg-accent" : "bg-line"} disabled:opacity-60`}
                >
                  <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-surface transition-all ${f.enabled ? "left-[22px]" : "left-0.5"}`} />
                </button>
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </div>
  );
}
